/* LD · Página de colección estilo ADOR (lógica de filtros basada en Dawn, licencia MIT de Shopify) */
(function () {
  if (window.ldCollectionLoaded) return;
  window.ldCollectionLoaded = true;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function root() { return document.querySelector('.ldC'); }

  var Facets = {
    cache: [],
    initial: window.location.search.slice(1),
    prev: window.location.search.slice(1),

    sectionId: function () {
      var r = root();
      return r ? r.dataset.section : null;
    },

    renderPage: function (searchParams, event, updateURL) {
      if (updateURL === undefined) updateURL = true;
      Facets.prev = searchParams;
      var r = root();
      if (!r) return;
      r.classList.add('is-loading');
      var url = window.location.pathname + '?section_id=' + Facets.sectionId() + (searchParams ? '&' + searchParams : '');
      var cached = Facets.cache.find(function (item) { return item.url === url; });
      if (cached) {
        Facets.renderSection(cached.html, event);
      } else {
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            Facets.cache.push({ url: url, html: html });
            Facets.renderSection(html, event);
          })
          .catch(function () { window.location.search = searchParams; });
      }
      if (updateURL) {
        history.pushState({ searchParams: searchParams }, '', window.location.pathname + (searchParams ? '?' + searchParams : ''));
      }
    },

    renderSection: function (html, event) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var r = root();

      /* Filtros: se actualiza el contenido manteniendo abierto el que se está usando */
      var selector = '#ldC-FiltersForm .js-filter, #ldC-FiltersFormMobile .js-filter';
      var fresh = Array.prototype.slice.call(doc.querySelectorAll(selector));
      var current = Array.prototype.slice.call(document.querySelectorAll(selector));
      current.forEach(function (el) {
        if (!fresh.some(function (f) { return f.id === el.id; })) el.remove();
      });
      var activeId = event && event.target && event.target.closest ? (event.target.closest('.js-filter') || {}).id : null;
      var focusId = event && event.target ? event.target.id : null;
      fresh.forEach(function (el) {
        var target = document.getElementById(el.id);
        if (target) target.innerHTML = el.innerHTML;
      });
      if (activeId && focusId) {
        var input = document.getElementById(focusId);
        if (input && input.type !== 'text') input.focus({ preventScroll: true });
      }

      ['.ldC-pills--desktop', '.ldC-pills--mobile', '.ldC-mcount', '#ldC-CountDesktop', '#ldC-Count'].forEach(function (sel) {
        var src = doc.querySelector(sel);
        var dst = document.querySelector(sel);
        if (src && dst) dst.innerHTML = src.innerHTML;
      });

      var grid = doc.getElementById('ldC-GridContainer');
      var gridDst = document.getElementById('ldC-GridContainer');
      if (grid && gridDst) gridDst.innerHTML = grid.innerHTML;

      if (r) r.classList.remove('is-loading');
      document.dispatchEvent(new CustomEvent('ldC:rendered'));
    },

    paramsFrom: function (form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      return params.toString();
    }
  };

  window.addEventListener('popstate', function (event) {
    var params = event.state ? event.state.searchParams : Facets.initial;
    if (params === Facets.prev) return;
    Facets.renderPage(params, null, false);
  });

  class LdFacetsForm extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      var form = this.querySelector('form');
      if (!form) return;
      var self = this;
      form.addEventListener('input', debounce(function (event) { self.onSubmit(event); }, 800));
      form.addEventListener('submit', function (event) { event.preventDefault(); });
    }

    onSubmit(event) {
      var form = event.target.closest('form');
      var params;
      if (form.id === 'ldC-FiltersFormMobile') {
        params = Facets.paramsFrom(form);
      } else {
        params = Facets.paramsFrom(document.getElementById('ldC-FiltersForm'));
      }
      Facets.renderPage(params, event);
    }
  }

  class LdFacetRemove extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      var link = this.querySelector('a');
      if (!link) return;
      link.setAttribute('role', 'button');
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var href = link.href;
        var params = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
        Facets.renderPage(params);
      });
    }
  }

  class LdPriceRange extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      var self = this;
      this.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('change', function () { self.adjust(input); self.setLimits(); });
        input.addEventListener('keydown', function (event) {
          if (event.metaKey || event.ctrlKey) return;
          if (!/[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/.test(event.key)) event.preventDefault();
        });
      });
      this.setLimits();
    }

    setLimits() {
      var inputs = this.querySelectorAll('input');
      var min = inputs[0];
      var max = inputs[1];
      if (max.value) min.setAttribute('data-max', max.value);
      if (min.value) max.setAttribute('data-min', min.value);
      if (min.value === '') max.setAttribute('data-min', 0);
      if (max.value === '') min.setAttribute('data-max', max.getAttribute('data-max'));
    }

    adjust(input) {
      var value = Number(input.value.replace(',', '.'));
      var min = Number(String(input.getAttribute('data-min')).replace(',', '.'));
      var max = Number(String(input.getAttribute('data-max')).replace(',', '.'));
      if (input.value === '') return;
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }

  /* Panel lateral de filtros en móvil */
  class LdMenuDrawer extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.main = this.querySelector('details');
      var self = this;
      this.addEventListener('click', function (event) {
        var summary = event.target.closest('summary');
        if (summary && self.contains(summary)) {
          event.preventDefault();
          var details = summary.parentElement;
          if (details === self.main) {
            details.classList.contains('menu-opening') ? self.close() : self.open();
          } else {
            self.openSub(details);
          }
          return;
        }
        if (event.target.closest('.ldC-mback')) {
          event.preventDefault();
          self.closeSub(event.target.closest('details'));
          return;
        }
        if (event.target.closest('[data-ldc-apply]')) {
          event.preventDefault();
          self.close();
        }
      });
      this.addEventListener('keyup', function (event) {
        if (event.key !== 'Escape') return;
        var sub = self.querySelector('.ldC-mdetails[open]');
        sub ? self.closeSub(sub) : self.close();
      });
      document.addEventListener('ldC:rendered', function () {
        /* El contenido del submenú abierto se ha renovado: mantener su estado */
        var sub = self.querySelector('.ldC-mdetails[open]');
        if (sub) sub.classList.add('menu-opening');
      });
    }

    open() {
      var details = this.main;
      details.setAttribute('open', '');
      requestAnimationFrame(function () { details.classList.add('menu-opening'); });
      document.documentElement.classList.add('ldC-lock');
    }

    close() {
      var details = this.main;
      details.classList.remove('menu-opening');
      this.querySelectorAll('.ldC-mdetails[open]').forEach(function (sub) {
        sub.classList.remove('menu-opening');
        sub.removeAttribute('open');
      });
      var mainList = this.querySelector('.ldC-mmain');
      if (mainList) mainList.classList.remove('submenu-open');
      document.documentElement.classList.remove('ldC-lock');
      setTimeout(function () { if (!details.classList.contains('menu-opening')) details.removeAttribute('open'); }, 400);
      var summary = details.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
    }

    openSub(details) {
      details.setAttribute('open', '');
      var mainList = this.querySelector('.ldC-mmain');
      if (mainList) mainList.classList.add('submenu-open');
      requestAnimationFrame(function () { details.classList.add('menu-opening'); });
    }

    closeSub(details) {
      if (!details) return;
      details.classList.remove('menu-opening');
      var mainList = this.querySelector('.ldC-mmain');
      if (mainList) mainList.classList.remove('submenu-open');
      setTimeout(function () { if (!details.classList.contains('menu-opening')) details.removeAttribute('open'); }, 400);
    }
  }

  if (!customElements.get('ld-facets-form')) customElements.define('ld-facets-form', LdFacetsForm);
  if (!customElements.get('ld-facet-remove')) customElements.define('ld-facet-remove', LdFacetRemove);
  if (!customElements.get('ld-price-range')) customElements.define('ld-price-range', LdPriceRange);
  if (!customElements.get('ld-menu-drawer')) customElements.define('ld-menu-drawer', LdMenuDrawer);

  /* Desplegables de escritorio: la capa invisible del resumen abierto recoge el clic fuera y lo cierra (como Dawn) */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.ldC-summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (details.hasAttribute('open')) {
      event.preventDefault();
      details.removeAttribute('open');
    }
  }, true);
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ldC-disc[open]').forEach(function (details) {
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  /* Muestras de color de la tarjeta: cambian la foto al color elegido */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.ldC-sw__btn');
    if (!btn) return;
    event.preventDefault();
    var card = btn.closest('.ldC-card');
    if (!card) return;
    card.querySelectorAll('.ldC-sw__btn.is-on').forEach(function (b) { b.classList.remove('is-on'); });
    btn.classList.add('is-on');
    var img = card.querySelector('.ldC-card__img1');
    if (img && btn.dataset.img) {
      img.removeAttribute('srcset');
      if (btn.dataset.srcset) img.setAttribute('srcset', btn.dataset.srcset);
      img.src = btn.dataset.img;
    }
    if (btn.dataset.url) {
      card.querySelectorAll('a.ldC-card__link').forEach(function (a) { a.href = btn.dataset.url; });
    }
  });
})();
